export default __webpack_public_path__ + "a947bf020b26ea85daa17dfd2a1a17e902ab18ff/161a231856ba99f96b16b1f91115e718.png";